import logo from "./logo.svg";
import ing from "./ing.png";
import youngCapital from "./young-capital.png";
import arcLogo from "./arc.png";
import onlyFriendsLogo from "./onlyfriends.png";

import { useState, useEffect } from "react";
import { polyfillCountryFlagEmojis } from "country-flag-emoji-polyfill";

const copy = {
  nl: {
    title: "ARC-Heitingatoernooi 2026",
    welcome: "Kies je toernooi om door te gaan:",
    u12_link_title: "ING Young Talent Tournament",
    main_link_title: "Young Capital Toernooi",
  },
  en: {
    title: "ARC-Heitingatoernooi 2026",
    welcome: "Choose your tournament to continue:",
    u12_link_title: "ING Young Talent Tournament",
    main_link_title: "Young Capital Tournament",
  },
  sv: {
    title: "ARC-Heitingatoernooi 2026",
    welcome: "Välj din turnering för att fortsätta:",
    u12_link_title: "ING Young Talent Tournament",
    main_link_title: "Young Capital Turnering",
  },
  de: {
    title: "ARC-Heitingatoernooi 2026",
    welcome: "Wählen Sie Ihr Turnier, um fortzufahren:",
    u12_link_title: "ING Young Talent Tournament",
    main_link_title: "Young Capital Turnier",
  },
  fr: {
    title: "ARC-Heitingatoernooi 2026",
    welcome: "Choisissez votre tournoi pour continuer:",
    u12_link_title: "ING Young Talent Tournament",
    main_link_title: "Young Capital Tournoi",
  },
  pt: {
    title: "ARC-Heitingatoernooi 2026",
    welcome: "Escolha seu torneio para continuar:",
    u12_link_title: "ING Young Talent Tournament",
    main_link_title: "Young Capital Torneio",
  },
  it: {
    title: "ARC-Heitingatoernooi 2026",
    welcome: "Scegli il tuo torneo per continuare:",
    u12_link_title: "ING Young Talent Tournament",
    main_link_title: "Young Capital Torneo",
  },
};

function App() {
  polyfillCountryFlagEmojis();

  const [locale, setLocale] = useState(localStorage.getItem("locale") || "nl");

  // useEffect(() => {
  //   window.location.href = `https://heitingatoernooi-u12.vercel.app/?locale=${locale}`;
  // }, [locale]);

  const handleLocaleChange = (event) => {
    localStorage.setItem("locale", event.target.value);
    setLocale(event.target.value);
  };

  const tournamentDate = new Date("2026-05-13");
  const currentDate = new Date();

  const differenceMs = tournamentDate.getTime() - currentDate.getTime();
  const differenceDays = Math.ceil(differenceMs / (1000 * 60 * 60 * 24));

  const counter = (
    <div className='w-screen h-screen bg-[#242631] text-white flex items-center justify-center'>
      <div className='text-center leading-loose space-y-3 p-8'>
        <img src={logo} alt='ARC-Heitingatoernooi logo' width='100' className='mx-auto mb-2' />

        <div className='text-2xl font-bold'>Nog {differenceDays} dagen tot het toernooi!</div>
        <div>
          Houd onze{" "}
          <a href='https://arc-heitingatoernooi.nl/' className='underline font-bold'>
            website
          </a>{" "}
          en{" "}
          <a href='https://www.facebook.com/ARCHeitingatoernooi' className='underline font-bold'>
            socials
          </a>{" "}
          in de gaten voor meer informatie.
        </div>
      </div>
    </div>
  );

  const fullApp = (
    <main className='flex flex-col gap-6 min-h-screen justify-center'>
      <div className='absolute top-4 right-4'>
        <select className='p-2 ml-2' onChange={handleLocaleChange} defaultValue={locale}>
          <option value='nl'>🇳🇱</option>
          <option value='en'>🇬🇧</option>
          <option value='sv'>🇸🇪</option>
          <option value='de'>🇩🇪</option>
          <option value='fr'>🇫🇷</option>
          <option value='pt'>🇵🇹</option>
          <option value='it'>🇮🇹</option>
        </select>
      </div>
      <div className='text-center justify-start mt-10'>
        <img src={logo} alt='ARC-Heitingatoernooi logo' width='100' className='mx-auto mb-2' />
        <h1 className='text-lg font-bold'>{copy[locale].title}</h1>
        <p>{copy[locale].welcome}</p>
      </div>

      <div className='px-12'>
        <div className='flex flex-col items-center justify-center mx-auto max-w-xs bg-[#fff7f5] border border-[#B92E29] rounded-lg shadow-sm px-3 py-1'>
          <div className='text-gray-700 font-semibold text-[9px] mb-0.5'>Wo 13 mei 16:00 · veld A</div>
          <div className='flex items-center justify-center w-full gap-3'>
            <div className='flex items-center justify-end w-2/5 min-w-0 gap-1'>
              <span className='font-bold text-[11px] text-[#B92E29] text-center'>ARC JG</span>
              <img
                src={arcLogo}
                alt='ARC JG'
                className='w-7 h-7 rounded-full border border-gray-300 bg-white mb-0.5'
              />
            </div>
            <div className='flex flex-col items-center min-w-0'>
              <div className='flex items-center justify-center bg-white border-2 border-[#B92E29] rounded px-2 py-0.5 text-[10px] font-extrabold text-[#242631] shadow-sm min-w-[45px]'>
                <span>2</span>
                <span className='mx-1 text-[#B92E29]'>-</span>
                <span>3</span>
              </div>
            </div>

            <div className='flex flex-col items-center min-w-0'>-</div>
            <div className='flex items-center w-2/5 min-w-0 gap-1'>
              <img
                src={onlyFriendsLogo}
                alt='Only Friends JG'
                className='w-7 h-7 rounded-full border border-gray-300 bg-white mb-0.5'
              />
              <span className='font-bold text-[11px] text-[#B92E29] text-center'>Only Friends JG</span>
            </div>
          </div>
          <div className='text-[10px] text-gray-400 text-center mt-0.5'>
            Mogelijk gemaakt door <span className='font-bold text-[#4b5563]'>Autismecentrum de Basis</span>
          </div>
        </div>
      </div>

      <div className='flex flex-col items-center justify-center space-y-3 lg:flex-row lg:space-y-0 lg:space-x-4 w-full max-w-xs mx-auto sm:max-w-full'>
        <a
          href={`https://heitingatoernooi.vercel.app/?locale=${locale}`}
          className='flex items-center justify-center text-center w-full h-20 text-base font-bold text-white bg-[#B92E29] rounded-lg shadow-lg lg:w-56 hover:bg-[#9b2622] transition-all duration-150'
        >
          {copy[locale].main_link_title}
        </a>
        <a
          href={`https://heitingatoernooi-u12.vercel.app/?locale=${locale}`}
          className='flex items-center justify-center text-center w-full h-20 text-base font-bold text-white bg-[#B92E29] rounded-lg shadow-lg lg:w-56 hover:bg-[#9b2622] transition-all duration-150'
        >
          {copy[locale].u12_link_title}
        </a>
      </div>

      <div className='w-full flex flex-col items-center justify-end pb-4'>
        <hr className='w-2/3 border-t border-gray-200 mb-3' />
        <div className='flex items-center mx-auto gap-10 mt-0 opacity-90'>
          <div className='w-20 text-center'>
            <img src={youngCapital} alt='Young Capital' className='w-20 h-20 object-contain mx-auto' />
          </div>
          <div className='w-20 text-center'>
            <img src={ing} alt='ing' className='w-14 h-14 object-contain mx-auto' />
          </div>
        </div>
      </div>
    </main>
  );

  // return differenceDays > 0 ? counter : fullApp;
  return fullApp;
}

export default App;
